import React from "react";
import { optionsCivilite, optionsIndice } from "../../../utils/selectOptions";
import Select from "../../UI/Select";

const FormMandataire = ({
  formData,
  handleChange,
  inputFocus,
  handleTrimValue,
  handleChangeMandataireConfirm,
}) => {
  return (
    <>
      <div className="background--warning p-3 mt-4">
        <div className="row pb-4">
          <div className="col-12 col-md-2">
            <Select
              label="Civilité :"
              selectClassName="page-1-required mandataire-group"
              name="MandataireCivil"
              value={formData.MandataireCivil || ""}
              handleChange={handleChange}
              inputFocus={inputFocus}
              options={optionsCivilite}
            />
          </div>
          <div className="col-12 col-md-5 mt-3 mt-md-0 position-relative">
            <label htmlFor="MandatairePrenom" className="form-label">
              Prénom&nbsp;:&nbsp;<span className="text-danger">*</span>
            </label>
            <input
              type="text"
              className="form-control page-1-required mandataire-group getLabel"
              id="MandatairePrenom"
              name="MandatairePrenom"
              maxLength={30}
              value={formData.MandatairePrenom || ""}
              onChange={handleChange}
              onInput={inputFocus}
              onBlur={handleTrimValue}
              required
              autoComplete="nope"
            />
            <div className="invalid-tooltip">
              Veuillez remplir ce champs obligatoire
            </div>
          </div>
          <div className="col-12 col-md-5 mt-3 mt-md-0 position-relative">
            <label htmlFor="MandataireNom" className="form-label">
              Nom d'usage&nbsp;:&nbsp;<span className="text-danger">*</span>
            </label>
            <input
              type="text"
              className="form-control page-1-required mandataire-group getLabel"
              id="MandataireNom"
              name="MandataireNom"
              maxLength={30}
              value={formData.MandataireNom || ""}
              onChange={handleChange}
              onInput={inputFocus}
              onBlur={handleTrimValue}
              required
              autoComplete="nope"
            />
            <div className="invalid-tooltip">
              Veuillez remplir ce champs obligatoire
            </div>
          </div>
        </div>
        <div className="row pb-4">
          <div className="col-12 col-md-4 position-relative">
            <label htmlFor="MandataireAdrNum" className="form-label">
              Numéro de voie <span className="text-danger">(facultatif)</span>
              &nbsp;:
            </label>
            <input
              type="text"
              pattern="[0-9]+"
              maxLength={5}
              className="form-control mandataire-group inputReg getLabel"
              id="MandataireAdrNum"
              name="MandataireAdrNum"
              value={formData.MandataireAdrNum || ""}
              onChange={handleChange}
              onInput={inputFocus}
              onBlur={handleTrimValue}
              autoComplete="nope"
            />
            <div className="invalid-tooltip">
              Veuillez entrer un numéro valide
            </div>
          </div>
          <div className="col-12 col-md-3 mt-3 mt-md-0">
            <Select
              label="Indice de répétition :"
              selectClassName="page-1-required mandataire-group getLabel"
              name="MandataireAdrRepetition"
              value={formData.MandataireAdrRepetition || ""}
              handleChange={handleChange}
              inputFocus={inputFocus}
              onBlur={handleTrimValue}
              options={optionsIndice}
            />
          </div>
          <div className="col-12 col-md-5 mt-3 mt-md-0 position-relative">
            <label htmlFor="MandataireAdrRue" className="form-label">
              Type et nom de voie&nbsp;:&nbsp;
              <span className="text-danger">*</span>
            </label>
            <input
              type="text"
              className="form-control page-1-required mandataire-group getLabel"
              id="MandataireAdrRue"
              name="MandataireAdrRue"
              maxLength={50}
              value={formData.MandataireAdrRue || ""}
              onInput={inputFocus}
              onChange={handleChange}
              onBlur={handleTrimValue}
              required
              autoComplete="nope"
            />
            <div className="invalid-tooltip">
              Veuillez remplir ce champs obligatoire
            </div>
          </div>
        </div>
        <div className="row pb-4">
          <div className="col-12 mt-3 mt-md-0 position-relative">
            <label htmlFor="MandataireAdrComp" className="form-label">
              Complément d'adresse{" "}
              <span className="text-danger">(facultatif)</span>&nbsp;:&nbsp;
            </label>
            <input
              type="text"
              className="form-control mandataire-group getLabel"
              id="MandataireAdrComp"
              name="MandataireAdrComp"
              maxLength={50}
              value={formData.MandataireAdrComp || ""}
              onInput={inputFocus}
              onChange={handleChange}
              onBlur={handleTrimValue}
              autoComplete="nope"
            />
          </div>
        </div>
        <div className="row pb-4">
          <div className="col-12 col-md-4 position-relative">
            <label htmlFor="MandataireAdrCP" className="form-label">
              Code postal&nbsp;:&nbsp;<span className="text-danger">*</span>
            </label>
            <input
              type="text"
              className="form-control page-1-required mandataire-group inputReg getLabel"
              id="MandataireAdrCP"
              name="MandataireAdrCP"
              value={formData.MandataireAdrCP || ""}
              onChange={handleChange}
              onInput={inputFocus}
              onBlur={handleTrimValue}
              required
              autoComplete="nope"
            />
            <div className="invalid-tooltip">
              Veuillez entrer un code postal valide
            </div>
          </div>
          <div className="col-12 col-md-4 mt-3 mt-md-0 position-relative">
            <label htmlFor="MandataireAdrVille" className="form-label">
              Commune&nbsp;:&nbsp;<span className="text-danger">*</span>
            </label>
            <input
              type="text"
              className="form-control page-1-required mandataire-group getLabel"
              id="MandataireAdrVille"
              name="MandataireAdrVille"
              maxLength={40}
              value={formData.MandataireAdrVille || ""}
              onChange={handleChange}
              onInput={inputFocus}
              onBlur={handleTrimValue}
              required
              autoComplete="nope"
            />
            <div className="invalid-tooltip">
              Veuillez remplir ce champs obligatoire
            </div>
          </div>
          <div className="col-12 col-md-4 mt-3 mt-md-0 position-relative">
            <label htmlFor="MandataireAdrPays" className="form-label">
              Pays&nbsp;:&nbsp;<span className="text-danger">*</span>
            </label>
            <input
              type="text"
              className="form-control page-1-required mandataire-group getLabel"
              id="MandataireAdrPays"
              name="MandataireAdrPays"
              maxLength={40}
              value={formData.MandataireAdrPays || ""}
              onChange={handleChange}
              onInput={inputFocus}
              onBlur={handleTrimValue}
              required
              autoComplete="nope"
            />
            <div className="invalid-tooltip">
              Veuillez remplir ce champs obligatoire
            </div>
          </div>
        </div>
        <div className="row pb-4">
          <div className="col-12 col-md-6 position-relative">
            <label htmlFor="MandataireEmail" className="form-label">
              Votre adresse e-mail&nbsp;:&nbsp;
              <span className="text-danger">*</span>
            </label>
            <input
              type="email"
              className="form-control page-1-required mandataire-group inputReg getLabel"
              id="MandataireEmail"
              name="MandataireEmail"
              maxLength={40}
              value={formData.MandataireEmail || ""}
              onChange={handleChange}
              onInput={inputFocus}
              onBlur={handleTrimValue}
              required
              placeholder="ex: email@example.com"
              autoComplete="nope"
            />
            <div className="invalid-tooltip">
              Veuillez entrer une adresse email valide
            </div>
          </div>
          <div className="col-12 col-md-6 pt-3 pt-md-0 position-relative">
            <label htmlFor="MandataireEmailConfirme" className="form-label">
              Confirmer votre adresse e-mail&nbsp;:&nbsp;
              <span className="text-danger">*</span>
            </label>
            <input
              type="email"
              className="form-control page-1-required confirmMandataireEmail mandataire-group getLabel"
              id="MandataireEmailConfirme"
              name="MandataireEmailConfirme"
              maxLength={40}
              value={formData.MandataireEmailConfirme || ""}
              onChange={handleChangeMandataireConfirm}
              onInput={inputFocus}
              onBlur={handleTrimValue}
              required
              onPaste={(e) => e.preventDefault()}
              placeholder="ex: email@example.com"
              autoComplete="nope"
            />
            <div className="invalid-tooltip">
              Veuillez entrer une adresse email identique
            </div>
          </div>
        </div>
        <div className="row pb-4">
          <div className="col-12 col-md-5 mt-3 mt-md-0 position-relative">
            <label htmlFor="MandataireRaisSos" className="form-label">
              Dénomination et raison sociale{" "}
              <span className="text-danger">(facultatif)</span>&nbsp;:&nbsp;
            </label>
            <input
              type="text"
              className="form-control page-1-required mandataire-group getLabel"
              id="MandataireRaisSos"
              name="MandataireRaisSos"
              maxLength={30}
              value={formData.MandataireRaisSos || ""}
              onChange={handleChange}
              onInput={inputFocus}
              onBlur={handleTrimValue}
              autoComplete="nope"
            />
          </div>
          <div className="col-12 col-md-4 mt-3 mt-md-0 position-relative">
            <label htmlFor="MandataireTypeSoc" className="form-label">
              Type de société <span className="text-danger">(facultatif)</span>
              &nbsp;:&nbsp;
            </label>
            <input
              type="text"
              className="form-control page-1-required mandataire-group getLabel"
              id="MandataireTypeSoc"
              name="MandataireTypeSoc"
              maxLength={30}
              value={formData.MandataireTypeSoc || ""}
              onChange={handleChange}
              onInput={inputFocus}
              onBlur={handleTrimValue}
              autoComplete="nope"
            />
          </div>
          <div className="col-12 col-md-3 mt-3 mt-md-0 position-relative">
            <label htmlFor="MandataireSiret" className="form-label">
              Siret <span className="text-danger">(facultatif)</span>
              &nbsp;:&nbsp;
            </label>
            <input
              type="text"
              className="form-control page-1-required mandataire-group getLabel"
              id="MandataireSiret"
              name="MandataireSiret"
              maxLength={30}
              value={formData.MandataireSiret || ""}
              onChange={handleChange}
              onInput={inputFocus}
              onBlur={handleTrimValue}
              autoComplete="nope"
            />
          </div>
        </div>
        <div className="row">
          <div className="col-12 col-md-6 position-relative">
            <label htmlFor="MandataireTel" className="form-label">
              Votre numéro de téléphone portable&nbsp;:&nbsp;
              <span className="text-danger">*</span>
            </label>
            <input
              type="tel"
              pattern="[0-9+]+"
              maxLength={15}
              className="form-control page-1-required mandataire-group inputReg getLabel"
              id="MandataireTel"
              name="MandataireTel"
              value={formData.MandataireTel || ""}
              onChange={handleChange}
              onInput={inputFocus}
              onBlur={handleTrimValue}
              required
              placeholder="ex: 0601020304"
              autoComplete="nope"
            />
            <div className="invalid-tooltip">
              Veuillez entrer un numéro de téléphone portable valide
            </div>
          </div>
          <div className="col-12 col-md-6 mt-3 mt-md-0 position-relative">
            <label htmlFor="MandataireTelFixe" className="form-label">
              Votre numéro de téléphone fixe{" "}
              <span className="text-danger">(facultatif)</span>&nbsp;:
            </label>
            <input
              type="tel"
              pattern="[0-9]+"
              maxLength={15}
              className="form-control page-1-required mandataire-group inputReg getLabel"
              id="MandataireTelFixe"
              name="MandataireTelFixe"
              value={formData.MandataireTelFixe || ""}
              onChange={handleChange}
              onInput={inputFocus}
              onBlur={handleTrimValue}
              placeholder="ex: 0235010203"
              autoComplete="nope"
            />
            <div className="invalid-tooltip">
              Veuillez entrer un numéro de téléphone valide
            </div>
          </div>
        </div>
      </div>
      <div className="alert alert-info mt-4">
        <i className="fas fa-info-circle"></i>&nbsp;
        <strong>Pour information :</strong>&nbsp;le mandataire désigne tout
        tiers mandaté par le demandeur pour remplir son dossier de changement
        d'usage (ex : conciergerie, agence de gestion locative, ...).
      </div>
    </>
  );
};

export default FormMandataire;
